import { Component, Host, h, Element, Listen, State, Prop } from '@stencil/core'

@Component({
  tag: 'bam-footer',
  styleUrl: 'bam-footer.scss',
  shadow: false
})
export class BamFooter {
  @Element() footerEl: HTMLElement

  @Prop() subtext?: string
  @Prop() entity?: string
  @Prop() isCompact?: boolean
  @Prop() isTcs?: boolean

  @State() isExpanded: boolean = false

  private intersectionO?: IntersectionObserver
  private intersectionObserverSupported: boolean

  @Listen('scroll',{ target: 'window' })
  handleScroll() {
    if (!this.isCompact && !this.intersectionObserverSupported) {
      this.setFooterWidth()
    } else if (this.isCompact && !this.intersectionObserverSupported) {
      this.isExpanded = true
    }
  }

  setFooterWidth = () => {
    const footerTop = this.footerEl.getBoundingClientRect().top
    const windowHeight = window.innerHeight || document.documentElement.clientHeight
    this.isExpanded = (footerTop + 50) < windowHeight
  }

  componentWillLoad() {
    this.isExpanded = this.isCompact
    /*if(!this.isCompact) {
      this.setFooterWidth();
    } else {
      this.isExpanded = true
    }*/

    const event = new CustomEvent("footer-ready", {});
    window.dispatchEvent(event);
  }

  getIntersection() {
    /* Set our observer to observe footer */
    this.intersectionO.observe(this.footerEl)
  }

  /* The callback that will fire on intersection */
  onIntersect = (entries) => {
    entries.forEach((entry) => {
      this.isExpanded = entry.isIntersecting
    })
  }

  connectedCallback() {
    this.intersectionObserverSupported = 'IntersectionObserver' in window
      && 'IntersectionObserverEntry' in window
      && 'intersectionRatio' in window.IntersectionObserverEntry.prototype
    const observerOptions = {
      root: null,
      rootMargin: "-50px",
      threshold: [0,0.33,0.66,1]
    }
    this.intersectionO = new IntersectionObserver(this.onIntersect, observerOptions)
    this.intersectionObserverSupported && !this.isCompact && this.getIntersection()
  }

  render() {
    return (
      <Host
        class={{
          'block': true,
          'bam-footer': true,
          'bam-footer--is-compact': this.isCompact,
          'bam-footer--is-tcs': this.isTcs,
          [`bam-footer${this.isExpanded ? '--fullwidth' : '--compressed'}`]: true,
        }}>
        <div class='bam-footer__content-wrapper'>
          <div class='container is-wide'>
            <slot name='social-share'></slot>
            {!this.isCompact &&
              <div class="bam-footer__logo-wrapper mb-xx-large pt-x-large desktop:inline-flex align-items-center">
                <bal-logo class="mr-x-large"
                  color="white"
                ></bal-logo>
                  {this.entity && (
                    <div class="bam-footer__entity">
                      <bal-text class="text-small mb-none" color="white" space="none">{this.subtext}</bal-text>
                      <bal-text color="white" bold heading space="none">{this.entity}</bal-text>
                    </div>
                  )}
              </div>
            }
            <slot name='site-list'></slot>
            <slot name='meta-list'></slot>
          </div>
        </div>
      </Host>
    )
  }
}
